module.exports = __webpack_public_path__ + "images/logo-yellow_62c0f0d40dcd40a69fc3dc7c6790f3a0.png";